export const checkIsNameSetUp = (name: string | null | undefined) => {
  return !!(name && name.trim().length > 0)
}
